export default "__VITE_ASSET__CjZokL1N__"